import React, { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { resetPassword } from "../services/api";

export default function ResetPasswordPage() {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const token = params.get("token") || "";

  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [done, setDone] = useState(false);
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    if (!token) {
      setError("Invalid reset link. Please request a new one.");
      return;
    }
    if (password.length < 6) {
      setError("Password must be at least 6 characters.");
      return;
    }
    if (password !== confirm) {
      setError("Passwords do not match.");
      return;
    }

    setBusy(true);
    try {
      await resetPassword(token, password);
      setDone(true);
    } catch (err) {
      setError(err?.message || err?.detail || "Failed to reset password. The link may have expired.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div style={styles.page}>
      <div style={styles.card}>
        <h1 style={styles.title}>MAD Discovery</h1>
        <h2 style={styles.subtitle}>Set new password</h2>

        {done ? (
          <div style={styles.successBox}>
            <p style={{ margin: 0, fontWeight: 600 }}>Password reset successfully</p>
            <p style={{ margin: "8px 0 0", fontSize: 14, color: "#374151" }}>
              You can now log in with your new password.
            </p>
            <button
              onClick={() => navigate("/login")}
              style={{ ...styles.btn, marginTop: 16 }}
            >
              Go to login
            </button>
          </div>
        ) : (
          <form onSubmit={handleSubmit}>
            {error && <div style={styles.error}>{error}</div>}

            <label style={styles.label}>New password</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="At least 6 characters"
              required
              autoFocus
              style={styles.input}
            />

            <label style={styles.label}>Confirm password</label>
            <input
              type="password"
              value={confirm}
              onChange={(e) => setConfirm(e.target.value)}
              placeholder="Repeat password"
              required
              style={styles.input}
            />

            <button type="submit" disabled={busy} style={styles.btn}>
              {busy ? "Resetting..." : "Reset password"}
            </button>

            <button
              type="button"
              onClick={() => navigate("/login")}
              style={styles.linkBtn}
            >
              Back to login
            </button>
          </form>
        )}
      </div>
    </div>
  );
}

const styles = {
  page: {
    minHeight: "100vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    background: "#f4f5f7",
    padding: 20,
  },
  card: {
    background: "#fff",
    borderRadius: 16,
    padding: "40px 36px",
    width: "100%",
    maxWidth: 420,
    boxShadow: "0 4px 24px rgba(0,0,0,0.08)",
  },
  title: {
    margin: 0,
    fontSize: 22,
    fontWeight: 700,
    color: "#1a1f36",
  },
  subtitle: {
    margin: "8px 0 24px",
    fontSize: 16,
    fontWeight: 500,
    color: "#6b7280",
  },
  label: {
    display: "block",
    fontSize: 13,
    fontWeight: 600,
    color: "#374151",
    marginBottom: 6,
  },
  input: {
    width: "100%",
    padding: "10px 12px",
    fontSize: 15,
    border: "1px solid #d1d5db",
    borderRadius: 8,
    marginBottom: 20,
    boxSizing: "border-box",
    outline: "none",
  },
  btn: {
    width: "100%",
    padding: "12px 0",
    fontSize: 15,
    fontWeight: 600,
    color: "#fff",
    background: "#2563eb",
    border: "none",
    borderRadius: 8,
    cursor: "pointer",
  },
  linkBtn: {
    width: "100%",
    padding: "10px 0",
    fontSize: 14,
    color: "#2563eb",
    background: "none",
    border: "none",
    cursor: "pointer",
    marginTop: 12,
  },
  error: {
    background: "#fef2f2",
    color: "#991b1b",
    padding: "10px 14px",
    borderRadius: 8,
    fontSize: 14,
    marginBottom: 16,
  },
  successBox: {
    background: "#ecfdf5",
    border: "1px solid #a7f3d0",
    borderRadius: 10,
    padding: "20px",
    textAlign: "center",
  },
};
